import { Drawer, styled } from '@mui/material';
import { colors } from '@watter/shared-components';
import { actionFocus } from '../side-menu/sidemenu-styles';

export const CommonSlider = styled(Drawer)(({ theme }) => ({
    '& .MuiPaper-root': {
        width: '560px',
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.white,
        '& .sliderContent': {
            position: 'relative',
            height: '100%',
            paddingRight: theme.spacing(0.5),
            '& .closeBtn': {
                position: 'absolute',
                right: theme.spacing(1.5),
                top: theme.spacing(1.5),
                padding: theme.spacing(0.5),
                background: theme.palette.mode === 'dark' ? colors.blackColor : colors.lightGray,
                '& svg': {
                    fontSize: theme.spacing(2),
                },
                '&:active::after': {
                    ...actionFocus(),
                    transform: 'scale(1.1, 1.1)',
                },
            },
            '& .detailsForm': {
                padding: theme.spacing(0),
                boxShadow: 'none',
                borderRadius: theme.spacing(0),
                height: '100%',
                background: 'transparent',
                '& .details.profileDetails': {
                    rowGap: theme.spacing(3),
                },
                '&.cstUpdateInstaller': {
                    '& form': {
                        display: 'block',
                    },
                    '& .MuiGrid2-root': {
                        '& .MuiFormControl-root': {
                            position: 'relative',
                            '& .MuiFormHelperText-root': {
                                position: 'absolute',
                                bottom: theme.spacing(-2.5),
                                margin: '0px',
                            },
                        },
                    },
                },
                '&.cstWorkOrder': {
                    background: 'transparent',
                    height: 'auto',
                    '& .cstSelectProfile': {
                        width: '100%',
                    },
                    '& .react-datepicker-wrapper': {
                        '& .react-datepicker__input-container': {
                            '& .MuiSvgIcon-root': {
                                right: 0,
                            },
                            '& input': {
                                width: '100%',
                                padding: theme.spacing(1.25, 0),
                                background: 'transparent',
                                color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                                fontSize: theme.spacing(2),
                                fontWeight: 400,
                                fontFamily: 'good_sansregular',
                                borderWidth: '0px 0px 2px 0px',
                                '&:focus-visible,&:focus': {
                                    outline: 'none',
                                },
                            },
                        },
                    },
                    '& .react-datepicker__tab-loop': {
                        '& .react-datepicker-popper,& .react-datepicker': {
                            width: '90%',
                            border: 'none',
                        },
                        '& .react-datepicker': {
                            background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
                            boxShadow:
                                '0px 0px 2px 0px #00000005 inset,-6px -6px 16px 0px #FFFFFF0A,6px 6px 16px 16px #00000040',
                        },
                        '& .react-datepicker__month-container': {
                            width: '100%',
                            '& .react-datepicker__month,& .react-datepicker__header': {
                                '&.react-datepicker__header ': {
                                    background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
                                    '& .react-datepicker__current-month': {
                                        color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                                    },
                                },
                                '& .react-datepicker__current-month': {
                                    fontFamily: 'good_sansregular',
                                },
                                '& .react-datepicker__week,& .react-datepicker__day-names': {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(7, 1fr)',
                                    '& .react-datepicker__day,& .react-datepicker__day-name': {
                                        fontSize: theme.spacing(1.75),
                                        fontWeight: 400,
                                        fontFamily: 'good_sansregular',
                                        lineHeight: 2.5,
                                        width: '100%',
                                        color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,

                                        '&.react-datepicker__day--keyboard-selected,&.react-datepicker__day--selected,&:hover':
                                            {
                                                color: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
                                                background:
                                                    theme.palette.mode === 'dark' ? colors.white : colors.darkBgButton,
                                            },
                                    },
                                },
                            },
                        },
                    },
                },
            },
            '& .actionFooter': {
                padding: theme.spacing(0, 4),
                paddingBottom: theme.spacing(2),
                '& .MuiBox-root': {
                    width: '100%',
                },
            },
        },
    },
}));
